import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a calculator
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <CalculatorIcon width={12} />
 */
const CalculatorIcon = props => (
    <SvgIcon {...props}>
        <path
            d="M 43 42.300781 C 42.996094 43.546875 42.492188 44.738281 41.597656 45.621094 C
            40.703125 46.5 39.488281 46.996094 38.222656 47 L 4.777344 47 C 3.511719 46.996094
            2.296875 46.5 1.402344 45.621094 C 0.507812 44.738281 0.00390625 43.546875 0 42.300781
            L 0 4.699219 C 0.00390625 3.453125 0.507812 2.261719 1.402344 1.378906 C 2.296875
            0.5 3.511719 0.00390625 4.777344 0 L 38.222656 0 C 39.488281 0.00390625 40.703125 0.5
            41.597656 1.378906 C 42.492188 2.261719 42.996094 3.453125 43 4.699219 Z M 35.832031
            8.226562 C 35.832031 7.914062 35.707031 7.613281 35.484375 7.394531 C 35.257812
            7.171875 34.957031 7.050781 34.640625 7.050781 L 8.359375 7.050781 C 8.042969 7.050781
            7.742188 7.171875 7.515625 7.394531 C 7.292969 7.613281 7.167969 7.914062 7.167969
            8.226562 L 7.167969 15.273438 C 7.167969 15.585938 7.292969 15.886719 7.515625
            16.105469 C 7.742188 16.328125 8.042969 16.449219 8.359375 16.449219 L 34.640625
            16.449219 C 34.953125 16.445312 35.253906 16.320312 35.476562 16.101562 C 35.699219
            15.882812 35.828125 15.585938 35.832031 15.273438 Z M 14.332031 23.5 L 9.554688 23.5
            L 9.554688 28.199219 L 14.332031 28.199219 Z M 14.332031 32.898438 L 9.554688 32.898438
            L 9.554688 37.601562 L 14.332031 37.601562 Z M 33.445312 23.5 L 28.667969 23.5 L
            28.667969 28.199219 L 33.445312 28.199219 Z M 33.445312 32.898438 L 28.667969 32.898438
            L 28.667969 37.601562 L 33.445312 37.601562 Z M 23.890625 23.5 L 19.109375 23.5 L
            19.109375 28.199219 L 23.890625 28.199219 Z M 23.890625 32.898438 L 19.109375 32.898438
            L 19.109375 37.601562 L 23.890625 37.601562 Z M 23.890625 32.898438
        "
        />
    </SvgIcon>
)

CalculatorIcon.defaultProps = defaultProps

export { CalculatorIcon }
